import { type SanitisedMegaNav, MegaNavContentType } from './types';

import { SupportedLocation } from '@/modules/location/constants';

export const REVALIDATION_INTERVAL = 900;

function MEGANAV_UK(): SanitisedMegaNav {
  return [
    {
      label: 'Women',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: `See all women's`,
              slug: '/category/womens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/explore/ww-jeans/',
                  colourOverride: null,
                },
                {
                  label: 'Jumpers',
                  slug: '/category/womens/tops/jumpers/',
                  colourOverride: null,
                },
                {
                  label: 'Skirts',
                  slug: '/category/womens/bottoms/skirts/',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/womens/dresses/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'Bags & Purses',
                  slug: '/category/womens/accessories/bag/',
                  colourOverride: null,
                },
                {
                  label: 'Sunglasses',
                  slug: '/category/womens/accessories/sunglasses/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/womens/accessories/hat/?subcategories=151',
                  colourOverride: null,
                },
                {
                  label: 'Jewellery',
                  slug: '/category/womens/accessories/jewellery/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/womens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Plus Size',
                  slug: '/explore/womens-plus-size-clothing-uk/',
                  colourOverride: null,
                },
                {
                  label: 'Festival',
                  slug: '/explore/womens-festival-fashion-uk/',
                  colourOverride: null,
                },
                {
                  label: 'Race day',
                  slug: '/explore/womens-race-day-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'Summer holiday',
                  slug: '/explore/womens-holiday-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'The bridal edit',
                  slug: '/explore/the-bridal-edit/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/womens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4hWgvXooWNz9ieUIiAKBk8/508ea4a36a7a401bc55b61807902fe30/300x200_6.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aZGZWEiHbXbMOTLs5X8YU/579d960dd6f7e307a5d3379b646ff969/312x208_6.webp',
                    description: '',
                  },
                },
                {
                  label: 'Coquette',
                  hideLabel: false,
                  slug: '/explore/coquette-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xG68AOpWBZgMEtLhp6ogL/1da4d27f2a68bd653ce29cf9c609865b/300x200_3.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2RHsPBIERL7X4hRsC5V1JA/c807746f9ed6c0e8916a3a65dc743c6d/312x208_3.webp',
                    description: '',
                  },
                },
                {
                  label: 'Y2K',
                  hideLabel: false,
                  slug: '/explore/y2k-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2qtMD6HVnD05VXpkYNR97N/00e47f9b8fa042ca0f75fd81534df772/300x200_2.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4tS2dowANgg3yuPHgFYFis/e94f7e868f644ed7295de232aa46bbde/312x208_2.webp',
                    description: '',
                  },
                },
                {
                  label: 'Boho',
                  hideLabel: false,
                  slug: '/explore/boho-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5JLDFdXa4MqOq5WvOziQA8/2e2c257046a8e5639ba9965a900ecac4/300x200_4.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4usKx9YC4WZtX4U1EZ36gG/c34f6261e1ed51346840e45b2b082663/312x208_4.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Men',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: `See all men's`,
              slug: '/category/mens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'T-shirts',
                  slug: '/category/mens/tops/tshirts/',
                  colourOverride: null,
                },
                {
                  label: 'Shirts',
                  slug: '/category/mens/tops/shirts/',
                  colourOverride: null,
                },
                {
                  label: 'Hoodies',
                  slug: '/category/mens/tops/hoodies/',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/',
                  colourOverride: null,
                },
                {
                  label: 'Jumpers',
                  slug: '/category/mens/tops/jumpers/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'Bags',
                  slug: '/category/mens/accessories/bag/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/mens/accessories/hat/',
                  colourOverride: null,
                },
                {
                  label: 'Sunglasses',
                  slug: '/category/mens/accessories/sunglasses/',
                  colourOverride: null,
                },
                {
                  label: 'Jewellery',
                  slug: '/category/mens/accessories/jewellery/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/mens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Black tie',
                  slug: '/explore/mens-black-tie-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'Festival',
                  slug: '/explore/mens-festival-fashion-uk/',
                  colourOverride: null,
                },
                {
                  label: 'Graduation',
                  slug: '/explore/mens-graduation-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'Summer holiday',
                  slug: '/explore/mens-holiday-clothing/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/mens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Gorpcore',
                  hideLabel: false,
                  slug: '/explore/gorpcore-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6J2C8qHJ3XXXcYNRY70SvX/e77e12661fa0cdd0cb9d0d7344b08d3f/300x200_7.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3uvCKGrp2ycqueYrMBCMAy/2244bdb89a283ae6b8660e14fc3d3908/312x208_7.webp',
                    description: '',
                  },
                },
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/79xHtlOwC8qbYl4NwsEoDP/0ffcf2583e6bba3d6ec6d068afc29e10/300x200_5.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6KGGZzJWxf6SPCq6mSL8UV/bf083f66c4da70e5ef006560b9817f25/312x208_5.png',
                    description: '',
                  },
                },
                {
                  label: 'Streetwear',
                  hideLabel: false,
                  slug: '/explore/mens-streetwear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/32JunfUqgEV6OuECb8gsuc/e989fc4d2717f7098a3fad1908b1957f/300x200_8.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/668qVrKHAhUwi7AFOKkXzF/bcb6516b7e1411652e385e494f766229/312x208_8.webp',
                    description: '',
                  },
                },
                {
                  label: 'Workwear',
                  hideLabel: false,
                  slug: '/explore/mens-workwear-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7oIizfyd1kHDk8rfanNG7z/92618222bfdd0e8accbf74e14b2f8db1/300x200_1.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7hiSfhzsRMy67R0dWN8Jth/44c664b5cf7fd968f2bfc2f79c3dfa9d/312x208_1.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Kids',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: 'See all kids',
              slug: '/category/kids/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/kids/tops',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/kids/bottoms',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/kids/dresses',
                  colourOverride: null,
                },
                {
                  label: 'Jackets',
                  slug: '/category/kids/coats-jackets',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/kids/shoes',
                  colourOverride: null,
                },
                {
                  label: 'Bundles',
                  slug: '/category/kids/bundles',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Popular brands',
            itemsCollection: {
              items: [
                {
                  label: 'Crocs',
                  slug: '/brands/crocs/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: `Levi's`,
                  slug: '/brands/levi-s/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Marks & Spencer',
                  slug: '/brands/marks-spencer/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Nike',
                  slug: '/brands/nike/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Ralph Lauren',
                  slug: '/brands/ralph-lauren/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'The North Face',
                  slug: '/brands/the-north-face/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop by gender',
            itemsCollection: {
              items: [
                {
                  label: 'Boy',
                  slug: '/explore/uk-kw-boy',
                  colourOverride: null,
                },
                {
                  label: 'Girl',
                  slug: '/explore/uk-kw-girl',
                  colourOverride: null,
                },
                {
                  label: 'Unisex',
                  slug: '/explore/uk-kw-unisex',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by age',
            itemsCollection: {
              items: [
                {
                  label: 'Baby (0-12m)',
                  hideLabel: false,
                  slug: '/explore/uk-kw-age-baby/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7DzQ0T9teatgwI5HXZ2KsM/e597e6c918f8438f8c662a5e6d9088f9/DepopKids-Meganav_tiles-Teen-d__2_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/70J37iInjF3pVIysBLDRwv/2c3cf531af60677d54a05881108ca5ef/DepopKids-Meganav_tiles-Teen-m__3_.png',
                    description: '',
                  },
                },
                {
                  label: ' Toddler (1-3 years)',
                  hideLabel: false,
                  slug: '/explore/uk-kw-age-toddler/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5KDgmcK3DEACAm2S8Elpbq/c87db99fb110355880553fbdfb461036/DepopKids-Meganav_tiles-Teen-d__3_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1SUkwLTGMTzyjKogFO0WQx/037bfd17f59b5f72cd74bb1d338c2509/DepopKids-Meganav_tiles-Teen-m__4_.png',
                    description: '',
                  },
                },
                {
                  label: ' Child (4-12 years)',
                  hideLabel: false,
                  slug: '/explore/uk-kw-age-child/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aaAHJAD0wVTzajWvhleE3/e1614bfa8b494af6c238fe59d8eb4fba/DepopKids-Meganav_tiles-Teen-d__4_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6YaUGi6amozozQcsi5iYFN/1287d99d5d350066a293fe2ebcdf4b75/DepopKids-Meganav_tiles-Teen-m__5_.png',
                    description: '',
                  },
                },
                {
                  label: 'Teen (13-16 years)',
                  hideLabel: false,
                  slug: '/explore/uk-kw-age-teen/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3YyoYfRXQhllMVX6H2Dlnw/3a5e43ae0b86a83c83bddd0064040ea9/DepopKids-Meganav_tiles-Teen-d__5_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3OXYaopplVA7bD5RcFGtJ6/f59c790b7d8aa80ce981ef072cb13730/DepopKids-Meganav_tiles-Teen-m.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Brands',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Popular brands',
            footer: {
              label: 'See all brands',
              slug: '/brands/a-z',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Adidas',
                  slug: '/brands/adidas/',
                  colourOverride: null,
                },
                {
                  label: 'Brandy Melville',
                  slug: '/brands/brandy-melville/',
                  colourOverride: null,
                },
                {
                  label: 'Converse',
                  slug: '/brands/converse/',
                  colourOverride: null,
                },
                {
                  label: 'Corteiz',
                  slug: '/brands/corteiz/',
                  colourOverride: null,
                },
                {
                  label: 'Free People',
                  slug: '/brands/free-people/',
                  colourOverride: null,
                },
                {
                  label: 'Gymshark',
                  slug: '/brands/gymshark/',
                  colourOverride: null,
                },
                {
                  label: 'Jordan',
                  slug: '/brands/jordan/',
                  colourOverride: null,
                },
                {
                  label: `Levi's`,
                  slug: '/brands/levi-s/',
                  colourOverride: null,
                },
                {
                  label: 'Lululemon',
                  slug: '/brands/lululemon/',
                  colourOverride: null,
                },
                {
                  label: 'New Balance',
                  slug: '/brands/new-balance/',
                  colourOverride: null,
                },
                {
                  label: 'Nike',
                  slug: '/brands/nike/',
                  colourOverride: null,
                },
                {
                  label: 'Patagonia',
                  slug: '/brands/patagonia/',
                  colourOverride: null,
                },
                {
                  label: 'Polo Ralph Lauren',
                  slug: '/brands/polo-ralph-lauren/',
                  colourOverride: null,
                },
                {
                  label: 'Puma',
                  slug: '/brands/puma/',
                  colourOverride: null,
                },
                {
                  label: 'Stüssy',
                  slug: '/brands/stussy/',
                  colourOverride: null,
                },
                {
                  label: 'Urban Outfitters',
                  slug: '/brands/urban-outfitters/',
                  colourOverride: null,
                },
                {
                  label: 'Vans',
                  slug: '/brands/vans/',
                  colourOverride: null,
                },
                {
                  label: 'Zara',
                  slug: '/brands/zara/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Carhartt',
                  hideLabel: false,
                  slug: '/brands/carhartt/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7oZnebEovISGZtCEo2Vg46/9bb08c0e8b2959fcb2a8fd27a4c31591/240716_DEPOP0007__1_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/tZlL6l2Iilpy1pey0o5d1/ba4efd3bceba563a229606e0667f6afc/240716_DEPOP0007__2_.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Dr. Martens',
                  hideLabel: false,
                  slug: '/brands/dr-martens/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7p9eFIX7dssEa5gYrXbe9k/6dbb465a39422b09a2ea5ef4285c1c16/240226_DEPOP0234__1_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4tnVBahWTrAEjQD3lxFdq/431609983e6648d223d0bc4b1b1290e4/240226_DEPOP0234__2___1_.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Trending',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Trending in women's`,
            footer: {
              label: 'See our Fall/Winter trends',
              slug: '/explore/fall-winter-2025-fashion-trends-trending/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Boots weather',
                  slug: '/explore/womens-boots-styles-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Outerwear season',
                  slug: '/explore/womens-trending-outerwear/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/womens-partywear-uk/',
                  colourOverride: null,
                },
                {
                  label: 'The bridal edit',
                  slug: '/explore/the-bridal-edit/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/womens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: `Trending in men's`,
            itemsCollection: {
              items: [
                {
                  label: 'Black tie',
                  slug: '/explore/mens-boots-styles/',
                  colourOverride: null,
                },
                {
                  label: 'Boots weather',
                  slug: '/explore/mens-boots-styles/',
                  colourOverride: null,
                },
                {
                  label: 'Outerwear season',
                  slug: '/explore/mens-trending-outerwear/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/mens-partywear-uk/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/mens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Trending items',
            itemsCollection: {
              items: [
                {
                  label: 'Barn jackets',
                  slug: '/explore/barn-jackets-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Cardigans',
                  slug: '/explore/cardigans-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Festive knits',
                  slug: '/explore/festive-knits-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Henley tops',
                  slug: '/explore/henley-tops-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Knee high boots',
                  slug: '/explore/knee-high-boots-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Sherpa jackets',
                  slug: '/explore/sherpa-jackets-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Pea coats',
                  slug: '/explore/pea-coats-trending/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by sport',
            itemsCollection: {
              items: [
                {
                  label: 'Cashmere',
                  hideLabel: false,
                  slug: '/explore/cashmere-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/52g6y8f2wX1QdHJMUrfFSW/0b7f33e663d88ed80f487ed54c161f08/Cashmere_300x200__2_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5AB4DkKHmE4g2jcRhCrIbl/9a243aef5ac611e61ed97c54f0ccbacc/Cashmere_312x208.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Suede',
                  hideLabel: false,
                  slug: '/explore/suede-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3cOwmZoZdMwGbp0NORgimJ/397b910537d11cde4f7b69a97b6e114a/Suede_300x200.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/Aj7JAY5ixJI0UpnrSh63k/c67dda763bacedf337cb42c369397506/Suede_312x208.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Plaid',
                  hideLabel: false,
                  slug: '/explore/plaid-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/72GqBEsS0QASxy0wxHTucP/0484981535192ab1cf383eff535df7f5/Checkered_300x200__2_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4eFj7Zm1Kx9Ann3mQX6wQS/456afbbfe554ac66ecf825fd5469acf8/Checkered_300x200.webp',
                    description: '',
                  },
                },
                {
                  label: 'Animal print',
                  hideLabel: false,
                  slug: '/explore/animal-print-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xPcxSSFX0F04WwWkPfwRG/680c5800a5d8786a343c604d420e81da/Animal_print_300x200.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1Gc6KW9EQjgsQqCmzmPwOH/f10553338c383f07f67ce2d14e41fd24/Animal_print_300x200.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Sale',
      colourOverride: '#E20020',
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Women's sale`,
            footer: {
              label: `See all women's sale`,
              slug: '/category/womens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/womens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/womens/dresses/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bags & Purses',
                  slug: '/category/womens/accessories/bag/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories',
                  slug: '/category/womens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/womens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Skirts',
                  slug: '/category/womens/bottoms/skirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Going out dresses',
                  slug: '/category/womens/dresses/dresses/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Hoodies',
                  slug: '/category/womens/tops/hoodies/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Trainers',
                  slug: '/category/womens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Men's sale`,
            footer: {
              label: `See all men's sale`,
              slug: '/category/mens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/mens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms ',
                  slug: '/category/mens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories ',
                  slug: '/category/mens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/mens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Hoodies',
                  slug: '/category/mens/tops/hoodies/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sweatshirts',
                  slug: '/category/mens/tops/sweatshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Cargo trousers',
                  slug: '/search/?q=mens+cargo+pants&isDiscounted=true&gender=male&groups=bottoms',
                  colourOverride: null,
                },
                {
                  label: 'Trainers',
                  slug: '/category/mens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/mens/accessories/hat/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Under £100',
                  hideLabel: true,
                  slug: '/explore/under-100/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6ctXpIQNDorHDNk9kB8CHf/d8508aaddae8cbf7a63b998305b0890d/300x200-6.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1DiQbJ4vvaYjcDcgltM9fo/1c3fad3587395d12c9a1bb275e18f549/312x208-6.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under £50',
                  hideLabel: true,
                  slug: '/explore/under-50/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6hFVM68PE4SRiDNoCMwmCO/8af8dd7c9e5701a6346bfb0ae4822f14/300x200-1.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2AA9Pb9iWeiWPY0QCLMOPw/9f84213c929a9c61861326cb451e8022/312x208-1.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under £20',
                  hideLabel: true,
                  slug: '/explore/under-20/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xTYvKWhMVNRqCWcmKMloz/ab037043f9cad4e33c0ce5ce8ca721ef/300x200-4.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/M6k8f3i8hWU4GN15R2CMP/f71ce3ab6ccf3c54bff068d31e2e9c3a/312x208-4.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under £10',
                  hideLabel: true,
                  slug: '/explore/under-10/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6KksrnCDXvskr7OlXaX9zw/4ba3029d2b4d2a208d7fa82386a24f2b/300x200.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1IoS8WrgnXrrZpiIns89yZ/389f3c8235ebfea8366efbff86cb49de/312x208.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ];
}

function MEGANAV_US(): SanitisedMegaNav {
  return [
    {
      label: 'Women',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: `See all women's`,
              slug: '/category/womens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/explore/ww-jeans/',
                  colourOverride: null,
                },
                {
                  label: 'Sweaters',
                  slug: '/category/womens/tops/jumpers/',
                  colourOverride: null,
                },
                {
                  label: 'Skirts',
                  slug: '/category/womens/bottoms/skirts/',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/womens/dresses/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'Bags & Purses',
                  slug: '/category/womens/accessories/bag/',
                  colourOverride: null,
                },
                {
                  label: 'Sunglasses',
                  slug: '/category/womens/accessories/sunglasses/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/womens/accessories/hat/?subcategories=151',
                  colourOverride: null,
                },
                {
                  label: 'Jewelry',
                  slug: '/category/womens/accessories/jewellery/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/womens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Plus Size',
                  slug: '/explore/womens-plus-size-clothing-us/',
                  colourOverride: null,
                },
                {
                  label: 'Festival',
                  slug: '/explore/womens-festival-fashion-us/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/womens-partywear-us/',
                  colourOverride: null,
                },
                {
                  label: 'Summer vacation',
                  slug: '/explore/womens-vacation-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'The bridal edit',
                  slug: '/explore/the-bridal-edit/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/womens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4hWgvXooWNz9ieUIiAKBk8/508ea4a36a7a401bc55b61807902fe30/300x200_6.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aZGZWEiHbXbMOTLs5X8YU/579d960dd6f7e307a5d3379b646ff969/312x208_6.webp',
                    description: '',
                  },
                },
                {
                  label: 'Coquette',
                  hideLabel: false,
                  slug: '/explore/coquette-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xG68AOpWBZgMEtLhp6ogL/1da4d27f2a68bd653ce29cf9c609865b/300x200_3.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2RHsPBIERL7X4hRsC5V1JA/c807746f9ed6c0e8916a3a65dc743c6d/312x208_3.webp',
                    description: '',
                  },
                },
                {
                  label: 'Y2K',
                  hideLabel: false,
                  slug: '/explore/y2k-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2qtMD6HVnD05VXpkYNR97N/00e47f9b8fa042ca0f75fd81534df772/300x200_2.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4tS2dowANgg3yuPHgFYFis/e94f7e868f644ed7295de232aa46bbde/312x208_2.webp',
                    description: '',
                  },
                },
                {
                  label: 'Boho',
                  hideLabel: false,
                  slug: '/explore/boho-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5JLDFdXa4MqOq5WvOziQA8/2e2c257046a8e5639ba9965a900ecac4/300x200_4.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4usKx9YC4WZtX4U1EZ36gG/c34f6261e1ed51346840e45b2b082663/312x208_4.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Men',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: `See all men's`,
              slug: '/category/mens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'T-shirts',
                  slug: '/category/mens/tops/tshirts/',
                  colourOverride: null,
                },
                {
                  label: 'Shirts',
                  slug: '/category/mens/tops/shirts/',
                  colourOverride: null,
                },
                {
                  label: 'Hoodies',
                  slug: '/category/mens/tops/hoodies/',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/',
                  colourOverride: null,
                },
                {
                  label: 'Sweaters',
                  slug: '/category/mens/tops/jumpers/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'Bags',
                  slug: '/category/mens/accessories/bag/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/mens/accessories/hat/',
                  colourOverride: null,
                },
                {
                  label: 'Jewelry',
                  slug: '/category/mens/accessories/jewellery/',
                  colourOverride: null,
                },
                {
                  label: 'Sunglasses',
                  slug: '/category/mens/accessories/sunglasses/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/mens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Big & Tall',
                  slug: '/explore/mens-big-and-tall-clothing/',
                  colourOverride: null,
                },
                {
                  label: 'Black tie',
                  slug: '/explore/mens-black-tie-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'Festival',
                  slug: '/explore/mens-festival-fashion-us/',
                  colourOverride: null,
                },
                {
                  label: 'Summer vacation',
                  slug: '/explore/mens-vacation-outfits/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/mens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Gorpcore',
                  hideLabel: false,
                  slug: '/explore/gorpcore-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6J2C8qHJ3XXXcYNRY70SvX/e77e12661fa0cdd0cb9d0d7344b08d3f/300x200_7.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3uvCKGrp2ycqueYrMBCMAy/2244bdb89a283ae6b8660e14fc3d3908/312x208_7.webp',
                    description: '',
                  },
                },
                {
                  label: 'Streetwear',
                  hideLabel: false,
                  slug: '/explore/mens-streetwear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/32JunfUqgEV6OuECb8gsuc/e989fc4d2717f7098a3fad1908b1957f/300x200_8.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/668qVrKHAhUwi7AFOKkXzF/bcb6516b7e1411652e385e494f766229/312x208_8.webp',
                    description: '',
                  },
                },
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/79xHtlOwC8qbYl4NwsEoDP/0ffcf2583e6bba3d6ec6d068afc29e10/300x200_5.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6KGGZzJWxf6SPCq6mSL8UV/bf083f66c4da70e5ef006560b9817f25/312x208_5.png',
                    description: '',
                  },
                },
                {
                  label: 'Workwear',
                  hideLabel: false,
                  slug: '/explore/mens-workwear-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7oIizfyd1kHDk8rfanNG7z/92618222bfdd0e8accbf74e14b2f8db1/300x200_1.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7hiSfhzsRMy67R0dWN8Jth/44c664b5cf7fd968f2bfc2f79c3dfa9d/312x208_1.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Kids',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: 'See all kids',
              slug: '/category/kids/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/kids/tops',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/kids/bottoms',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/kids/dresses',
                  colourOverride: null,
                },
                {
                  label: 'Jackets',
                  slug: '/category/kids/coats-jackets',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/kids/shoes',
                  colourOverride: null,
                },
                {
                  label: 'Bundles',
                  slug: '/category/kids/bundles',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Popular brands',
            itemsCollection: {
              items: [
                {
                  label: 'Carhartt',
                  slug: '/brands/carhartt/c/kids/?isKids=true',
                  colourOverride: null,
                },
                {
                  label: `Carter's`,
                  slug: '/brands/carter-s/c/kids/?isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Gap',
                  slug: '/brands/gap/c/kids/?isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Nike',
                  slug: '/brands/nike/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: `OshKosh B'gosh`,
                  slug: '/brands/oshkosh-b-gosh/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Vans',
                  slug: '/brands/vans/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop by gender',
            itemsCollection: {
              items: [
                {
                  label: 'Boy',
                  slug: '/explore/us-kids-boy/',
                  colourOverride: null,
                },
                {
                  label: 'Girl',
                  slug: '/explore/us-kw-girl',
                  colourOverride: null,
                },
                {
                  label: 'Unisex',
                  slug: '/explore/us-kw-unisex',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by age',
            itemsCollection: {
              items: [
                {
                  label: 'Baby (0-12m)',
                  hideLabel: false,
                  slug: '/explore/us-kw-age-baby/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7DzQ0T9teatgwI5HXZ2KsM/e597e6c918f8438f8c662a5e6d9088f9/DepopKids-Meganav_tiles-Teen-d__2_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/70J37iInjF3pVIysBLDRwv/2c3cf531af60677d54a05881108ca5ef/DepopKids-Meganav_tiles-Teen-m__3_.png',
                    description: '',
                  },
                },
                {
                  label: ' Toddler (1-3 years)',
                  hideLabel: false,
                  slug: '/explore/us-kw-age-toddler/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5KDgmcK3DEACAm2S8Elpbq/c87db99fb110355880553fbdfb461036/DepopKids-Meganav_tiles-Teen-d__3_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1SUkwLTGMTzyjKogFO0WQx/037bfd17f59b5f72cd74bb1d338c2509/DepopKids-Meganav_tiles-Teen-m__4_.png',
                    description: '',
                  },
                },
                {
                  label: ' Child (4-12 years)',
                  hideLabel: false,
                  slug: '/explore/us-kw-age-child/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aaAHJAD0wVTzajWvhleE3/e1614bfa8b494af6c238fe59d8eb4fba/DepopKids-Meganav_tiles-Teen-d__4_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6YaUGi6amozozQcsi5iYFN/1287d99d5d350066a293fe2ebcdf4b75/DepopKids-Meganav_tiles-Teen-m__5_.png',
                    description: '',
                  },
                },
                {
                  label: 'Teen (13-16 years)',
                  hideLabel: false,
                  slug: '/explore/us-kw-age-teen/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3YyoYfRXQhllMVX6H2Dlnw/3a5e43ae0b86a83c83bddd0064040ea9/DepopKids-Meganav_tiles-Teen-d__5_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3OXYaopplVA7bD5RcFGtJ6/f59c790b7d8aa80ce981ef072cb13730/DepopKids-Meganav_tiles-Teen-m.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Brands',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Popular brands ',
            footer: {
              label: 'See all brands ',
              slug: '/brands/a-z',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Abercrombie & Fitch',
                  slug: '/brands/abercrombie-fitch/',
                  colourOverride: null,
                },
                {
                  label: 'Adidas',
                  slug: '/brands/adidas/',
                  colourOverride: null,
                },
                {
                  label: 'Brandy Melville',
                  slug: '/brands/brandy-melville/',
                  colourOverride: null,
                },
                {
                  label: 'Carhartt',
                  slug: '/brands/carhartt/',
                  colourOverride: null,
                },
                {
                  label: 'Dickies',
                  slug: '/brands/dickies/',
                  colourOverride: null,
                },
                {
                  label: 'Dr. Martens',
                  slug: '/brands/dr-martens/',
                  colourOverride: null,
                },
                {
                  label: 'Free People ',
                  slug: '/brands/free-people/',
                  colourOverride: null,
                },
                {
                  label: 'Harley Davidson ',
                  slug: '/brands/harley-davidson/',
                  colourOverride: null,
                },
                {
                  label: 'Jordan',
                  slug: '/brands/jordan/',
                  colourOverride: null,
                },
                {
                  label: 'Lululemon',
                  slug: '/brands/lululemon/',
                  colourOverride: null,
                },
                {
                  label: 'New Balance',
                  slug: '/brands/new-balance/',
                  colourOverride: null,
                },
                {
                  label: 'Nike',
                  slug: '/brands/nike/',
                  colourOverride: null,
                },
                {
                  label: 'Patagonia ',
                  slug: '/brands/patagonia/',
                  colourOverride: null,
                },
                {
                  label: 'Polo Ralph Lauren ',
                  slug: '/brands/polo-ralph-lauren/',
                  colourOverride: null,
                },
                {
                  label: 'Supreme',
                  slug: '/brands/supreme/',
                  colourOverride: null,
                },
                {
                  label: 'The North Face',
                  slug: '/brands/the-north-face/',
                  colourOverride: null,
                },
                {
                  label: 'Urban Outfitters',
                  slug: '/brands/urban-outfitters/',
                  colourOverride: null,
                },
                {
                  label: 'Zara',
                  slug: '/brands/zara/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Reformation',
                  hideLabel: false,
                  slug: '/explore/?brands=433%2C21828%2C23646%2C23657',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3tvPNLdg3HneXnSEQPHQgC/eac6f03af5fb90743cbc8276229cbabd/Reformation.webp',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/29p97t9AzAJTiUo8LmCOBg/fbc5705b7ed1855c10f80a7096288788/Reformation_mobile__1_.jpg',
                    description: '',
                  },
                },
                {
                  label: `Levi's`,
                  hideLabel: false,
                  slug: '/brands/levi-s/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/61wz0HfxKNwjqFWKCCNsAY/baf2af9162dcbe86a1d1e50233db9824/240723_DEPOP2369__1___1_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2EABUeQrT3Hwj2XJyNHeTS/c64f5e05619d4d5a99a49cc261b6df0f/240723_DEPOP2369__3___1_.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Sports',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: 'See all sportswear',
              slug: '/explore/see-all-sportswear-us/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Jerseys',
                  slug: '/explore/sports-jerseys-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/explore/sports-sneakers-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sweatpants',
                  slug: '/explore/sports-sweatpants-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sweatshirts',
                  slug: '/explore/sports-sweatshirts-us/',
                  colourOverride: null,
                },
                {
                  label: 'Tracksuits',
                  slug: '/explore/sports-tracksuits-us/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/explore/sports-hats-us/',
                  colourOverride: null,
                },
                {
                  label: 'Scarves',
                  slug: '/explore/sports-scarves-us/',
                  colourOverride: null,
                },
                {
                  label: 'Cleats',
                  slug: '/explore/sports-cleats-us/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop vintage',
            itemsCollection: {
              items: [
                {
                  label: 'Vintage jerseys',
                  slug: '/explore/vintage-sports-jerseys-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sneakers',
                  slug: '/explore/sports-vintage-sneakers-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sweatpants',
                  slug: '/explore/sports-vintage-sweatpants-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sweatshirts',
                  slug: '/explore/sports-vintage-sweatshirts-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage tracksuits',
                  slug: '/explore/sports-vintage-tracksuits-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage hats',
                  slug: '/explore/sports-vintage-hats-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage scarves',
                  slug: '/explore/sports-vintage-scarves-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage shorts',
                  slug: '/explore/sports-vintage-shorts-us/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop by league',
            itemsCollection: {
              items: [
                {
                  label: 'NFL',
                  slug: '/explore/nfl/',
                  colourOverride: null,
                },
                {
                  label: 'NHL',
                  slug: '/explore/nhl/',
                  colourOverride: null,
                },
                {
                  label: 'NBA',
                  slug: '/explore/nba/',
                  colourOverride: null,
                },
                {
                  label: 'MLB',
                  slug: '/explore/mlb/',
                  colourOverride: null,
                },
                {
                  label: 'NCAA',
                  slug: '/explore/its-tournament-time/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by sport',
            itemsCollection: {
              items: [
                {
                  label: 'F1',
                  hideLabel: false,
                  slug: '/explore/sports-F1-us/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/qfHHoOhcrfVqya1paRzsK/5e13a1526d241c03c5d705009d62f8da/4.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1wHblFmgiexG46DFRI9wWY/62c25619f7421b853cbcba986fcf9683/4.png',
                    description: '',
                  },
                },
                {
                  label: 'Yoga',
                  hideLabel: false,
                  slug: '/explore/sports-yoga-us/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1I2PShNi3mHMHU6EahlZN6/d294094f37df248a1b76f6fb408e707e/2.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5MgPuSJ9wJTiKHg87lv7w8/f4e40a82506f1f9ad6a4baf3db84cdfc/2.png',
                    description: '',
                  },
                },
                {
                  label: 'Running',
                  hideLabel: false,
                  slug: '/explore/sports-running-us/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4az9u2tOreXArMEVY3C03t/612eed7b500169018b79cc8bf4c4534b/3.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3N7ebksGIQ4dtrYDweJZyd/53ce9f6abcc875c76964df3af99da3cb/3.png',
                    description: '',
                  },
                },
                {
                  label: 'Soccer',
                  hideLabel: false,
                  slug: '/explore/sports-soccer-us/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4O8YgSmkgAPEhxMn7wOHwg/0de3a52776c4209cf9ab14b7f9cd7d58/1.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3U9PpfKyE34dK0f0uNQxdO/75de1c2681d28aa17765088292a75ccb/1.png',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Trending',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Trending in women's`,
            footer: {
              label: 'See our Fall/Winter trends',
              slug: '/explore/fall-winter-2025-fashion-trends-trending/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Boots weather',
                  slug: '/explore/womens-boots-styles-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Outerwear season',
                  slug: '/explore/womens-trending-outerwear/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/womens-partywear-us/',
                  colourOverride: null,
                },
                {
                  label: 'The bridal edit',
                  slug: '/explore/the-bridal-edit/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/womens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: `Trending in men's`,
            itemsCollection: {
              items: [
                {
                  label: 'Black tie',
                  slug: '/explore/mens-boots-styles/',
                  colourOverride: null,
                },
                {
                  label: 'Boots weather',
                  slug: '/explore/mens-boots-styles/',
                  colourOverride: null,
                },
                {
                  label: 'Outerwear season',
                  slug: '/explore/mens-trending-outerwear/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/mens-partywear-us/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/mens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Trending items',
            itemsCollection: {
              items: [
                {
                  label: 'Barn jackets',
                  slug: '/explore/barn-jackets-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Cardigans',
                  slug: '/explore/cardigans-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Festive knits',
                  slug: '/explore/festive-knits-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Henley tops',
                  slug: '/explore/henley-tops-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Knee high boots',
                  slug: '/explore/knee-high-boots-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Sherpa jackets',
                  slug: '/explore/sherpa-jackets-trending/',
                  colourOverride: null,
                },
                {
                  label: 'Pea coats',
                  slug: '/explore/pea-coats-trending/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by sport',
            itemsCollection: {
              items: [
                {
                  label: 'Cashmere',
                  hideLabel: false,
                  slug: '/explore/cashmere-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/52g6y8f2wX1QdHJMUrfFSW/0b7f33e663d88ed80f487ed54c161f08/Cashmere_300x200__2_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5AB4DkKHmE4g2jcRhCrIbl/9a243aef5ac611e61ed97c54f0ccbacc/Cashmere_312x208.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Suede',
                  hideLabel: false,
                  slug: '/explore/suede-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3cOwmZoZdMwGbp0NORgimJ/397b910537d11cde4f7b69a97b6e114a/Suede_300x200.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/Aj7JAY5ixJI0UpnrSh63k/c67dda763bacedf337cb42c369397506/Suede_312x208.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Plaid',
                  hideLabel: false,
                  slug: '/explore/plaid-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/72GqBEsS0QASxy0wxHTucP/0484981535192ab1cf383eff535df7f5/Checkered_300x200__2_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4eFj7Zm1Kx9Ann3mQX6wQS/456afbbfe554ac66ecf825fd5469acf8/Checkered_300x200.webp',
                    description: '',
                  },
                },
                {
                  label: 'Animal print',
                  hideLabel: false,
                  slug: '/explore/animal-print-trending/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xPcxSSFX0F04WwWkPfwRG/680c5800a5d8786a343c604d420e81da/Animal_print_300x200.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1Gc6KW9EQjgsQqCmzmPwOH/f10553338c383f07f67ce2d14e41fd24/Animal_print_300x200.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Sale',
      colourOverride: '#E20020',
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Women's sale`,
            footer: {
              label: `See all women's sale`,
              slug: '/category/womens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/womens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/womens/dresses/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories',
                  slug: '/category/womens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/womens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bags & Purses',
                  slug: '/category/womens/accessories/bag/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Skirts',
                  slug: '/category/womens/bottoms/skirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Leather jackets',
                  slug: '/category/womens/coats-jackets/jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/womens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Boots',
                  slug: '/category/womens/footwear/boots/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Men's sale`,
            footer: {
              label: `See all men's sale`,
              slug: '/category/mens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/mens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/mens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories ',
                  slug: '/category/mens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/mens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sweaters',
                  slug: '/category/mens/tops/sweatshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Windbreakers',
                  slug: '/category/mens/coats-jackets/jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Casual pants',
                  slug: '/category/mens/bottoms/casual-pants/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/mens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Boots',
                  slug: '/category/mens/footwear/boots/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Under $100',
                  hideLabel: true,
                  slug: '/explore/sale-under-usd100/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7ySe1JebD4AYfVUI1YqbAh/a2594482e2b9a22fbe43434d566dc2bf/300x200-7.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2D5JdiZ8PbeSOqTF6WfV2f/9b954ffa06413c7366fe2a82e4d94635/312x208-7.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under $50',
                  hideLabel: true,
                  slug: '/explore/sale-under-usd50/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6i4iIf0Ii3BKnJA6P667kP/0f03eda2db8cea18c1c83b628162afa5/300x200-3.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6hE8jVKV41Hyq0sFOgk3NG/9a62c8698902b7af45ba146a5e3a225b/312x208-3.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under $20',
                  hideLabel: true,
                  slug: '/explore/sale-under-usd20/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/RJbfl2SgGjfG4PtiDpxCj/712bdd58e4cec6284ff319b135f8ed91/300x200-5.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5z4JbFabB5SNxLs6bPhku9/b954c91ae715664e5cff82d9a8392e4e/312x208-5.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Under $10',
                  hideLabel: true,
                  slug: '/explore/sale-under-usd10/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3bCCx5HCpXEhVt3qnNIYUJ/a50e6a46f838cf895494ec5e125f35d5/300x200-2.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1JUXxi7HvWEHiWkcdgUAoQ/c3a5d9eea11ab959c1c1162683fc47b9/312x208-2.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ];
}

function MEGANAV_AU(): SanitisedMegaNav {
  return [
    {
      label: 'Women',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category ',
            footer: {
              label: `See all women's`,
              slug: '/category/womens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/womens/bottoms/',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/womens/dresses/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/womens/tops/tshirts/',
                  colourOverride: null,
                },
                {
                  label: 'Sweatershirts',
                  slug: '/category/womens/tops/sweatshirts/',
                  colourOverride: null,
                },
                {
                  label: 'Accessories',
                  slug: '/category/womens/accessories/',
                  colourOverride: null,
                },
                {
                  label: 'Jewellery',
                  slug: '/category/womens/accessories/jewellery/',
                  colourOverride: null,
                },
                {
                  label: 'Bags and purses',
                  slug: '/explore/bags-and-purses-gifts/',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/mens/footwear/trainers/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/womens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Plus Size',
                  slug: '/explore/womens-plus-size-clothing-uk/',
                  colourOverride: null,
                },
                {
                  label: 'Festival',
                  slug: '/explore/womens-festival-fashion-us/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/womens-partywear-us/',
                  colourOverride: null,
                },
                {
                  label: 'The bridal edit',
                  slug: '/explore/the-bridal-edit/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/womens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4hWgvXooWNz9ieUIiAKBk8/508ea4a36a7a401bc55b61807902fe30/300x200_6.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aZGZWEiHbXbMOTLs5X8YU/579d960dd6f7e307a5d3379b646ff969/312x208_6.webp',
                    description: '',
                  },
                },
                {
                  label: 'Coquette',
                  hideLabel: false,
                  slug: '/explore/coquette-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1xG68AOpWBZgMEtLhp6ogL/1da4d27f2a68bd653ce29cf9c609865b/300x200_3.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2RHsPBIERL7X4hRsC5V1JA/c807746f9ed6c0e8916a3a65dc743c6d/312x208_3.webp',
                    description: '',
                  },
                },
                {
                  label: 'Y2K',
                  hideLabel: false,
                  slug: '/explore/y2k-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2qtMD6HVnD05VXpkYNR97N/00e47f9b8fa042ca0f75fd81534df772/300x200_2.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4tS2dowANgg3yuPHgFYFis/e94f7e868f644ed7295de232aa46bbde/312x208_2.webp',
                    description: '',
                  },
                },
                {
                  label: 'Boho',
                  hideLabel: false,
                  slug: '/explore/boho-womenswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5JLDFdXa4MqOq5WvOziQA8/2e2c257046a8e5639ba9965a900ecac4/300x200_4.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4usKx9YC4WZtX4U1EZ36gG/c34f6261e1ed51346840e45b2b082663/312x208_4.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Men',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: `See all men's`,
              slug: '/category/mens/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops ',
                  slug: '/category/mens/tops/',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms ',
                  slug: '/category/mens/bottoms/',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/',
                  colourOverride: null,
                },
                {
                  label: 'Jumpers',
                  slug: '/category/mens/tops/jumpers/',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/',
                  colourOverride: null,
                },
                {
                  label: 'Hoodies',
                  slug: '/category/mens/tops/hoodies/',
                  colourOverride: null,
                },
                {
                  label: 'Accessories ',
                  slug: '/category/mens/accessories/',
                  colourOverride: null,
                },
                {
                  label: 'Joggers',
                  slug: '/category/mens/bottoms/joggers-tracksuits/',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/mens/footwear/trainers/',
                  colourOverride: null,
                },
                {
                  label: 'Vests',
                  slug: '/category/mens/coats-jackets/gilets/',
                  colourOverride: null,
                },
                {
                  label: 'Sale',
                  slug: '/category/mens/?isDiscounted=true',
                  colourOverride: 'red',
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Featured',
            itemsCollection: {
              items: [
                {
                  label: 'Festival',
                  slug: '/explore/mens-festival-fashion-us/',
                  colourOverride: null,
                },
                {
                  label: 'Party fits',
                  slug: '/explore/mens-partywear-us/',
                  colourOverride: null,
                },
                {
                  label: 'Wedding guests',
                  slug: '/explore/mens-wedding-guest-outfits/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Gorpcore',
                  hideLabel: false,
                  slug: '/explore/gorpcore-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6J2C8qHJ3XXXcYNRY70SvX/e77e12661fa0cdd0cb9d0d7344b08d3f/300x200_7.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3uvCKGrp2ycqueYrMBCMAy/2244bdb89a283ae6b8660e14fc3d3908/312x208_7.webp',
                    description: '',
                  },
                },
                {
                  label: 'Minimalism',
                  hideLabel: false,
                  slug: '/explore/minimalist-menswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/79xHtlOwC8qbYl4NwsEoDP/0ffcf2583e6bba3d6ec6d068afc29e10/300x200_5.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6KGGZzJWxf6SPCq6mSL8UV/bf083f66c4da70e5ef006560b9817f25/312x208_5.png',
                    description: '',
                  },
                },
                {
                  label: 'Streetwear',
                  hideLabel: false,
                  slug: '/explore/mens-streetwear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/32JunfUqgEV6OuECb8gsuc/e989fc4d2717f7098a3fad1908b1957f/300x200_8.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/668qVrKHAhUwi7AFOKkXzF/bcb6516b7e1411652e385e494f766229/312x208_8.webp',
                    description: '',
                  },
                },
                {
                  label: 'Workwear',
                  hideLabel: false,
                  slug: '/explore/mens-workwear-style/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7oIizfyd1kHDk8rfanNG7z/92618222bfdd0e8accbf74e14b2f8db1/300x200_1.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7hiSfhzsRMy67R0dWN8Jth/44c664b5cf7fd968f2bfc2f79c3dfa9d/312x208_1.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Kids',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: 'See all kids',
              slug: '/category/kids/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/kids/tops',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/kids/bottoms',
                  colourOverride: null,
                },
                {
                  label: 'Dresses',
                  slug: '/category/kids/dresses',
                  colourOverride: null,
                },
                {
                  label: 'Jackets',
                  slug: '/category/kids/coats-jackets',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/kids/shoes',
                  colourOverride: null,
                },
                {
                  label: 'Bundles',
                  slug: '/category/kids/bundles',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Popular brands',
            itemsCollection: {
              items: [
                {
                  label: 'Bonds',
                  slug: '/brands/bonds/c/kids/?moduleOrigin=meganav&isKids=true',
                  colourOverride: null,
                },
                {
                  label: 'Country Road',
                  slug: '/brands/country-road/?moduleOrigin=meganav&sort=relevance',
                  colourOverride: null,
                },
                {
                  label: 'Jamie Kay',
                  slug: '/brands/jamie-kay/?moduleOrigin=meganav&sort=relevance',
                  colourOverride: null,
                },
                {
                  label: 'Nike',
                  slug: '/brands/nike/?moduleOrigin=meganav&sort=relevance',
                  colourOverride: null,
                },
                {
                  label: 'Seed Heritage',
                  slug: '/brands/seed-heritage/?moduleOrigin=meganav&sort=relevance',
                  colourOverride: null,
                },
                {
                  label: 'The North Face',
                  slug: '/brands/the-north-face/?moduleOrigin=meganav&sort=relevance',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop by gender',
            itemsCollection: {
              items: [
                {
                  label: 'Boy',
                  slug: '/explore/au-kw-boy',
                  colourOverride: null,
                },
                {
                  label: 'Girl',
                  slug: '/explore/au-kw-girl',
                  colourOverride: null,
                },
                {
                  label: 'Unisex',
                  slug: '/explore/au-kw-unisex',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by age',
            itemsCollection: {
              items: [
                {
                  label: 'Baby (0-12m)',
                  hideLabel: false,
                  slug: '/explore/au-kw-age-baby/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7DzQ0T9teatgwI5HXZ2KsM/e597e6c918f8438f8c662a5e6d9088f9/DepopKids-Meganav_tiles-Teen-d__2_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/70J37iInjF3pVIysBLDRwv/2c3cf531af60677d54a05881108ca5ef/DepopKids-Meganav_tiles-Teen-m__3_.png',
                    description: '',
                  },
                },
                {
                  label: ' Toddler (1-3 years)',
                  hideLabel: false,
                  slug: '/explore/au-kw-age-toddler/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5KDgmcK3DEACAm2S8Elpbq/c87db99fb110355880553fbdfb461036/DepopKids-Meganav_tiles-Teen-d__3_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/1SUkwLTGMTzyjKogFO0WQx/037bfd17f59b5f72cd74bb1d338c2509/DepopKids-Meganav_tiles-Teen-m__4_.png',
                    description: '',
                  },
                },
                {
                  label: ' Child (4-12 years)',
                  hideLabel: false,
                  slug: '/explore/au-kw-age-child/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5aaAHJAD0wVTzajWvhleE3/e1614bfa8b494af6c238fe59d8eb4fba/DepopKids-Meganav_tiles-Teen-d__4_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/6YaUGi6amozozQcsi5iYFN/1287d99d5d350066a293fe2ebcdf4b75/DepopKids-Meganav_tiles-Teen-m__5_.png',
                    description: '',
                  },
                },
                {
                  label: 'Teen (13-16 years)',
                  hideLabel: false,
                  slug: '/explore/au-kw-age-teen/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3YyoYfRXQhllMVX6H2Dlnw/3a5e43ae0b86a83c83bddd0064040ea9/DepopKids-Meganav_tiles-Teen-d__5_.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3OXYaopplVA7bD5RcFGtJ6/f59c790b7d8aa80ce981ef072cb13730/DepopKids-Meganav_tiles-Teen-m.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Brands',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Popular brands',
            footer: {
              label: 'See all brands',
              slug: '/brands/a-z',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Adidas ',
                  slug: '/brands/adidas/',
                  colourOverride: null,
                },
                {
                  label: 'Bec & Bridge',
                  slug: '/brands/bec-bridge/',
                  colourOverride: null,
                },
                {
                  label: 'Billabong',
                  slug: '/brands/billabong/',
                  colourOverride: null,
                },
                {
                  label: 'Carhartt',
                  slug: '/brands/carhartt/',
                  colourOverride: null,
                },
                {
                  label: 'Converse',
                  slug: '/brands/converse/',
                  colourOverride: null,
                },
                {
                  label: 'Dickies',
                  slug: '/brands/dickies/',
                  colourOverride: null,
                },
                {
                  label: 'Dr. Martens',
                  slug: '/brands/dr-martens/',
                  colourOverride: null,
                },
                {
                  label: 'KOOKAÏ',
                  slug: '/brands/kookai/',
                  colourOverride: null,
                },
                {
                  label: `Levi's`,
                  slug: '/brands/levi-s/',
                  colourOverride: null,
                },
                {
                  label: 'Lululemon',
                  slug: '/brands/lululemon/',
                  colourOverride: null,
                },
                {
                  label: 'New Balance',
                  slug: '/brands/new-balance/',
                  colourOverride: null,
                },
                {
                  label: 'Polo Ralph Lauren',
                  slug: '/brands/polo-ralph-lauren/',
                  colourOverride: null,
                },
                {
                  label: 'Réalisation Par',
                  slug: '/brands/realisation-par/',
                  colourOverride: null,
                },
                {
                  label: 'SIR.',
                  slug: '/brands/sir/',
                  colourOverride: null,
                },
                {
                  label: 'The North Face',
                  slug: '/brands/the-north-face/',
                  colourOverride: null,
                },
                {
                  label: 'With Jéan',
                  slug: '/brands/with-jean/',
                  colourOverride: null,
                },
                {
                  label: 'Zara',
                  slug: '/brands/zara/',
                  colourOverride: null,
                },
                {
                  label: 'Zimmermann',
                  slug: '/brands/zimmermann/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Dissh',
                  hideLabel: false,
                  slug: '/brands/dissh/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7KoJ8NiFkCeIPawrGzabge/d41b717a59ffbea48402cecb7b8aded2/P0_-_2025-06-02T130217.831__1_.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/FjCLqiRfAFFe0WNT9TGGs/3f3ad81158587b3b57e9f305c1d95fba/P0_-_2025-06-02T130217.831__2_.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Nike',
                  hideLabel: false,
                  slug: '/brands/nike/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/7EwE2BtSnPDM3N75JY25Zc/8fc1b96d5825a523b275df37a344e14e/P0---2025-06-02T144239.449.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/5jxHaovNB9ey3SZIdMIIvL/887e6d071f02ceeb4d407633a105419c/P0---2025-06-02T144239.449.jpg',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Sports',
      colourOverride: null,
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: 'Shop by category',
            footer: {
              label: 'See all sportswear',
              slug: '/explore/see-all-sportswear-us/',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Jerseys',
                  slug: '/explore/sports-jerseys-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/explore/sports-sneakers-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sweatpants',
                  slug: '/explore/sports-sweatpants-us/',
                  colourOverride: null,
                },
                {
                  label: 'Sweatshirts',
                  slug: '/explore/sports-sweatshirts-us/',
                  colourOverride: null,
                },
                {
                  label: 'Tracksuits',
                  slug: '/explore/sports-tracksuits-us/',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/explore/sports-hats-us/',
                  colourOverride: null,
                },
                {
                  label: 'Scarves',
                  slug: '/explore/sports-scarves-us/',
                  colourOverride: null,
                },
                {
                  label: 'Cleats',
                  slug: '/explore/sports-cleats-us/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            footer: null,
            title: 'Shop vintage',
            itemsCollection: {
              items: [
                {
                  label: 'Vintage jerseys',
                  slug: '/explore/vintage-sports-jerseys-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sneakers',
                  slug: '/explore/sports-vintage-sneakers-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sweatpants',
                  slug: '/explore/sports-vintage-sweatpants-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage sweatshirts',
                  slug: '/explore/sports-vintage-sweatshirts-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage tracksuits',
                  slug: '/explore/sports-vintage-tracksuits-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage hats',
                  slug: '/explore/sports-vintage-hats-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage scarves',
                  slug: '/explore/sports-vintage-scarves-us/',
                  colourOverride: null,
                },
                {
                  label: 'Vintage shorts',
                  slug: '/explore/sports-vintage-shorts-us/',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: 'Shop by sport',
            itemsCollection: {
              items: [
                {
                  label: 'AFL',
                  hideLabel: false,
                  slug: '/explore/afl-sportswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2Hr3Xd6Sd91VnUd5V3oXyi/644da0d9f3ec28031a1425a45d1c25bd/Untitled-1.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2Hr3Xd6Sd91VnUd5V3oXyi/644da0d9f3ec28031a1425a45d1c25bd/Untitled-1.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Rugby',
                  hideLabel: false,
                  slug: '/au/explore/rugby-sportswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4ccW1FUVCpmq3cZEupPptP/f50e188a5b897e38e836e0ddaead6dd6/Untitled-13.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4ccW1FUVCpmq3cZEupPptP/f50e188a5b897e38e836e0ddaead6dd6/Untitled-13.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Soccer',
                  hideLabel: false,
                  slug: '/explore/soccer-sportswear/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/CSh7ddeV9JVjynVXANdgg/428166aa900cca514010578bef420538/Untitled-14.jpg',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/CSh7ddeV9JVjynVXANdgg/428166aa900cca514010578bef420538/Untitled-14.jpg',
                    description: '',
                  },
                },
                {
                  label: 'Basketball',
                  hideLabel: false,
                  slug: '/explore/sports-soccer-us/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4O8YgSmkgAPEhxMn7wOHwg/0de3a52776c4209cf9ab14b7f9cd7d58/1.png',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/3U9PpfKyE34dK0f0uNQxdO/75de1c2681d28aa17765088292a75ccb/1.png',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      label: 'Sale',
      colourOverride: '#E20020',
      contentCollection: {
        items: [
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Women's sale`,
            footer: {
              label: `See all women's sale`,
              slug: '/category/womens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/womens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/womens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Dresses ',
                  slug: '/category/womens/dresses/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/womens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/womens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories',
                  slug: '/category/womens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/womens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bags & Purses',
                  slug: '/category/womens/accessories/bag/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Skirts',
                  slug: '/category/womens/bottoms/skirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Casual dresses',
                  slug: '/category/womens/dresses/dresses/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/womens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sandals',
                  slug: '/category/womens/footwear/sandals/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.CategoryList,
            title: `Men's sale`,
            footer: {
              label: `See all men's sale`,
              slug: '/category/mens/?isDiscounted=true',
              colourOverride: null,
            },
            itemsCollection: {
              items: [
                {
                  label: 'Tops',
                  slug: '/category/mens/tops/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Bottoms',
                  slug: '/category/mens/bottoms/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Coats & Jackets',
                  slug: '/category/mens/coats-jackets/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shoes',
                  slug: '/category/mens/footwear/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Accessories',
                  slug: '/category/mens/accessories/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'T-shirts',
                  slug: '/category/mens/tops/tshirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shirts',
                  slug: '/category/mens/tops/shirts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Jeans',
                  slug: '/category/mens/bottoms/jeans/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Shorts',
                  slug: '/category/mens/bottoms/shorts/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Sneakers',
                  slug: '/category/mens/footwear/trainers/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Vests',
                  slug: '/category/mens/tops/vests-tanks-camis/?isDiscounted=true',
                  colourOverride: null,
                },
                {
                  label: 'Hats',
                  slug: '/category/mens/accessories/hat/?isDiscounted=true',
                  colourOverride: null,
                },
              ],
            },
          },
          {
            __typename: MegaNavContentType.ImageLinkList,
            title: null,
            itemsCollection: {
              items: [
                {
                  label: 'Under A$100',
                  hideLabel: true,
                  slug: '/explore/sale-under-ausd100/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4CeUpekTJxDZCcYYtYX4WJ/c1512766350d995cfa45616c4d643b0c/Web_Nav_AU_Sale_Under_100_Desktop.webp',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/22sTDh1XIDoqnKIapOq9Xg/a808e7e1e987364aa325763e6722df6b/Web_Nav_AU_Sale_Under_100_Mobile.webp',
                    description: '',
                  },
                },
                {
                  label: 'Under A$50',
                  hideLabel: true,
                  slug: '/explore/sale-under-ausd50/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/JUomjBTy8cmqPdY7Wi1SJ/b3bdd194b9e112fbed28c35d0f92e63a/Web_Nav_AU_Sale_Under_50_Desktop.webp',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/VlUCkiw8JvIskq83JdmNA/5d451a48b0b5b609fbdb8038d324b50c/Web_Nav_AU_Sale_Under_50_Mobile.webp',
                    description: '',
                  },
                },
                {
                  label: 'Under A$20',
                  hideLabel: true,
                  slug: '/explore/sale-under-ausd20/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/47bTpSYHdetcy1Zb5SmPD1/868967639404478774e6aef39ed14ee1/Web_Nav_AU_Sale_Under_20_Desktop.webp',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4NZlnKkWLpTzKNTaW7btXN/f1809b715283f1466a4734dbbba74539/Web_Nav_AU_Sale_Under_20_Mobile.webp',
                    description: '',
                  },
                },
                {
                  label: 'Under A$10',
                  hideLabel: true,
                  slug: '/explore/sale-under-ausd10/',
                  imageDesktop: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/2RPXhlver0tPnbOPZCcqyA/e4f359e35d74da42501ce4ebfafe626a/Web_Nav_AU_Sale_Under_10_Desktop.webp',
                    description: '',
                  },
                  imageMobile: {
                    url: 'https://contentful.depop.com/itoh30v6uh9a/4dmvBMy9pzYu3MYSydvlKp/be3130cb3d442232e8513348904f10c9/Web_Nav_AU_Sale_Under_10_Mobile.webp',
                    description: '',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ];
}

export const MEGANAV_CONFIGS = {
  gb: MEGANAV_UK,
  us: MEGANAV_US,
  au: MEGANAV_AU,
};

export const CONTENTFUL_NAV_ID: Record<SupportedLocation, string> = {
  [SupportedLocation.GB]: '3I7jrys3ERms1F5eakM6Gb',
  [SupportedLocation.IT]: '49IfYQGqrTGngKH94MLDpt',
  [SupportedLocation.FR]: '1ZMImYPYseIW4YfxzhGZci',
  [SupportedLocation.DE]: '1TrhBygL4tKhfsn8fMDYm',
  [SupportedLocation.US]: '59LC8awkBBYyLUKEI4oK8Q',
  [SupportedLocation.AU]: '205qfb47C5sY05C2TjbfeC',
  [SupportedLocation.IE]: '3I7jrys3ERms1F5eakM6Gb', // fallback to GB
  [SupportedLocation.CA]: '59LC8awkBBYyLUKEI4oK8Q', // fallback to US
  [SupportedLocation.NZ]: '205qfb47C5sY05C2TjbfeC', // fallback to AU
};
